// @flow

import { TweenLite, Power2 } from "gsap/TweenMax";
import scrollToPlugin from "gsap/ScrollToPlugin";

const plugins = [scrollToPlugin]; // eslint-disable-line

export const scrollToEl = (toEl: any) => {
    const nav = document.querySelector(".primary-nav");
    TweenLite.to(window, 1, {
        scrollTo: {
            y: toEl,
            offsetY: nav ? nav.clientHeight : 0,
        },
        ease: Power2.easeInOut,
    });
};

export const scrollToTop = () => {
    TweenLite.to(window, 1, {
        scrollTo: {
            y: 0,
        },
        ease: Power2.easeInOut,
    });
};

window.addEventListener("click", (event: MouseEvent) => {
    if (event.target instanceof HTMLElement) {
        const el = event.target;
        if (el.matches('a[href*="#"]')) {
            const href = el.getAttribute("href") || "";
            const id = href.includes("#") ? href.split("#")[1] : "";
            const toEl = id && id !== "#" ? document.getElementById(id) : false;
            if (toEl) {
                event.preventDefault();
                scrollToEl(toEl);
            }
        }
    }
});
